import { Injectable } from '@angular/core';
import { ReviewSectionService } from './review-section.service';
import { ReviewSectionStore } from './review-section.store';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionHelpers {
  constructor(private reviewSectionService: ReviewSectionService, private reviewSectionStore: ReviewSectionStore) {}

  public initStoreData(applicationId: number | string): void {
    this.reviewSectionService
      .getSectionReviews(applicationId)
      .pipe(first())
      .subscribe(sectionReviews => {
        this.reviewSectionStore.setReviews(sectionReviews);
      });

    this.reviewSectionService
      .getSectionMessages(applicationId)
      .pipe(first())
      .subscribe(sectionReviews => {
        this.reviewSectionStore.setSectionMessages(sectionReviews);
      });
  }
}
